import request from '@/utils/request';
import {
  TMPURL
} from './config';

//获取全局配置信息
export function apiImGetBaseInfo(params) {
  return request.post(TMPURL + '/v1/frontend/im/getBaseInfo', params);
}

//获取历史聊天信息
export function apiImGetHistoryMessage(params) {
  return request.get(TMPURL + '/v1/public/im/getHistoryMessage', params);
}

//获取IM初始化配置
export function apiImInit(params) {
  return request.get(TMPURL + '/v1/public/im/init', params);
}

//获取IM初始化配置
export function apiImTransferToService(params) {
  return request.post(TMPURL + '/v1/frontend/im/transferToService', params);
}

//初始化
export function apiKfInit(params) {
  return request.get(TMPURL + '/v1/public/kf/init', params);
}

//获取客服首页所有数据
export function apiKfIndex(params) {
  return request.get(TMPURL + '/v1/public/kf/index', params);
}


// 转人工
export function apiKfTransferToService(params) {
  return request.post(TMPURL + '/v1/frontend/im/transferToService', params);
}

// 发送消息机器人
export function apiKfSendRobotMessage(params) {
  return request.post(TMPURL + '/v1/public/robot/sendMessage', params);
}

//获取全局公告
export function getGlobalNotice(params) {
  return request.get(TMPURL + '/v1/public/notice/getGlobalNotice', params);
}

//获取IM公告
export function apiGetImNotice(params) {
  return request.post(TMPURL + '/v1/frontend/notice/getImNoticeHandler', params);
}

// 有无帮助
export function apiRobotGrade(params) {
  return request.post(TMPURL + '/v1/public/robot/grade', params);
}

// 获取相似问题索引
export function apiLikeQuestion(params) {
  return request.get(TMPURL + '/v1/public/robot/questionLike', params);
}

// 夜间反馈
export function apiFeedBackNight(params) {
  return request.post(TMPURL + '/v1/frontend/im/feedBack', params, true, true);
}

// 猜你想问
export function apiGuessQuestion(params) {
  return request.get(TMPURL + '/v1/frontend/im/getPopulateQuestion', params);
}

// 获取提示语
export function apiMessageTips(params) {
  return request.get(TMPURL + '/v1/frontend/im/getMessageTips', params);
}